import { Cookie } from '@/utils'

export const UPDATE_AUTH = (state, auth, hiddenHeader) => {
    localStorage.setItem('CRM_TOKEN',auth.accessToken)
    Cookie.set('CRM_TOKEN',`${auth.accessToken}`,hiddenHeader)
    // document.cookie += `CRM_TOKEN=${auth.accessToken};${hiddenHeader?'samesite=None;secure;':''}`
    state.auth = auth
}

export const UPDATE_USER = (state, user) => {
    state.user = user
}

export const UPDATE_USER_AVATAR = (state, avatarUrl) => {
    state.user.avatarUrl = avatarUrl
}

/**
 * Clear each property, one by one, so reactivity still works.
 *
 * (ie. clear out state.auth.isLoggedIn so Navbar component automatically reacts to logged out state,
 * and the Navbar menu adjusts accordingly)
 *
 * TODO: use a common import of default state to reset these values with.
 */
export const CLEAR_ALL_DATA = (state) => {
    // Auth
    state.auth.isLoggedIn = false
    state.auth.accessToken = null
    state.auth.refreshToken = null
    // document.cookie += `CRM_TOKEN=''`
    Cookie.set('CRM_TOKEN','')
    localStorage.removeItem('CRM_TOKEN')
    localStorage.removeItem('refreshToken')

    // User
    state.user.userId = ''
    state.user.userName = ''
    state.user.nickName = ''
    state.user.loginType = ''
    state.user.departName = ''
    state.user.departId = ''
    state.user.avatarUrl = ''
    state.user.userType = ''
}

export const UPDATE_TABLE_HEIGHT = (state, tableHeight) => {
    state.tableHeight = tableHeight;
}

export const UPDATE_PAGE_BACKGROUND = (state, pageBackground) => {
    state.pageBackground = pageBackground;
}

export const UPDATE_NAV_COLLAPSE = (state, navCollapsed) => {
    state.navCollapsed = navCollapsed;
}

export const UPDATE_SEARCH_VALUE = (state, searchValue) => {
    state.searchValue = searchValue;
}


export const UPDATE_HIDDEN_HEADER = (state, hiddenHeader) => {
    state.hiddenHeader = hiddenHeader;
}

export const UPDATE_MENU_LIST = (state, menuList) => {
    state.menuList = menuList;
}

// export const SET_PAGE_SOURCE = (state, source) => {
//     state.pageSource = source;
// }

export const SET_STAFF_TYPE = (state, type) => {
    console.log('Mutation 收到数据:', type);
    state.staffType = type;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js